import type { FaireProductEntity } from "../../entity_types/product";

export const p_phw5y69rm6: FaireProductEntity = {
  token: "p_phw5y69rm6",
  type: "product",
  name: "Kato Mito Mochi Mystery Bao Gummy Tropical Mix (3oz)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl: "https://cdn.faire.com/fastly/55ef26b57a5cfd3af0082e5a204b100f49d40fc68aac1eaee2968b9b5b835d97.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.99,
  description: "Take your customers on a tropical trip this Q4. Kato Mito™ Mystery Mochi Bao Gummy Tropical Mix is the island flavored version of the viral mochi candy everyone is talking about, and it's one of our fastest movers this season.\n\nEach 3oz bag is filled with soft, squishy, chewy bao shaped gummies in bright tropical flavors like pineapple and mango. Every bite is a surprise because you never know which flavor you'll get next. That mystery factor keeps shoppers curious and coming back to try the whole lineup.\n\nStock it next to the Fruity Mix for a colorful display that drives add on sales. It works great in candy aisles, checkout counters, gift shops, toy stores, and anywhere trendy snacks sell.\n\n🍍 Juicy tropical flavors like pineapple and mango\n🍡 Soft, squishy mochi style gummy texture\n❓ Mystery flavor surprise in every bag\n🔥 Viral candy trend with strong social media buzz\n📦 Sold in cases of 12 x 3oz bags\n🛒 Bold packaging made for impulse sales\n🎁 Great for Q4 stocking stuffers and holiday gifting\n\nQ4 inventory is moving fast. Order now to keep your shelves full through the holidays.\n\nShowcase® is an authorized retailer of Kato Mito™\n\n",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:33.287Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
